import ForgetPasswordPage from "./ForgetPasswordPage";

export default ForgetPasswordPage;
